import type {
  CompleteSprintBody,
  CompleteSprintResponse,
  CreateSprintBody,
  Sprint,
  SprintIssuesBody,
  UpdateSprintBody,
} from '@tasks/contracts';

import type { SprintState } from '../lib/types';
import { apiRequest, apiRequestList, apiRequestVoid } from './client';

export function listSprints(projectKey: string, state?: SprintState, signal?: AbortSignal): Promise<Sprint[]> {
  return apiRequestList<Sprint>(`/projects/${encodeURIComponent(projectKey)}/sprints`, {
    query: { state },
    signal,
  });
}

export function createSprint(projectKey: string, body: CreateSprintBody): Promise<Sprint> {
  return apiRequest<Sprint>(`/projects/${encodeURIComponent(projectKey)}/sprints`, { method: 'POST', body });
}

export function updateSprint(sprintId: string, body: UpdateSprintBody): Promise<Sprint> {
  return apiRequest<Sprint>(`/sprints/${encodeURIComponent(sprintId)}`, { method: 'PATCH', body });
}

export function deleteSprint(sprintId: string): Promise<void> {
  return apiRequestVoid(`/sprints/${encodeURIComponent(sprintId)}`, { method: 'DELETE' });
}

export function startSprint(sprintId: string): Promise<Sprint> {
  return apiRequest<Sprint>(`/sprints/${encodeURIComponent(sprintId)}/start`, { method: 'POST' });
}

export function completeSprint(sprintId: string, body: CompleteSprintBody): Promise<CompleteSprintResponse> {
  return apiRequest<CompleteSprintResponse>(`/sprints/${encodeURIComponent(sprintId)}/complete`, {
    method: 'POST',
    body,
  });
}

export function addIssuesToSprint(sprintId: string, body: SprintIssuesBody): Promise<Sprint> {
  return apiRequest<Sprint>(`/sprints/${encodeURIComponent(sprintId)}/issues`, { method: 'POST', body });
}

export function removeIssuesFromSprint(sprintId: string, body: SprintIssuesBody): Promise<Sprint> {
  return apiRequest<Sprint>(`/sprints/${encodeURIComponent(sprintId)}/issues`, { method: 'DELETE', body });
}
